export const TabIdEnum = {
    stage: "stage",
    participants: "participants",
    ticketSystemIdeas: "ticketSystemIdeas",
    ticketSystemProblems: "ticketSystemProblems",
    ticketSystemDashboard: "ticketSystemDashboard",
    committees: "committees"
} as const;

export type TabIdEnum = typeof TabIdEnum[keyof typeof TabIdEnum];
